import { useState } from "react";

export interface AgreementState {
  healthDataTransfer: boolean;
  personalDataProvision: boolean;
  healthInfoProvision: boolean;
}

export const useAgreements = (initialState?: Partial<AgreementState>) => {
  const [agreements, setAgreements] = useState<AgreementState>({
    healthDataTransfer: false,
    personalDataProvision: false,
    healthInfoProvision: false,
    ...initialState,
  });

  const handleAgreementToggle = (key: keyof AgreementState) => {
    setAgreements((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const allAgreementsChecked = Object.values(agreements).every(Boolean);

  const handleAgreeAll = () => {
    const newValue = !allAgreementsChecked;
    setAgreements({
      healthDataTransfer: newValue,
      personalDataProvision: newValue,
      healthInfoProvision: newValue,
    });
  };

  const setAllAgreements = (value: boolean) => {
    setAgreements({
      healthDataTransfer: value,
      personalDataProvision: value,
      healthInfoProvision: value,
    });
  };

  return {
    agreements,
    setAgreements,
    handleAgreementToggle,
    allAgreementsChecked,
    handleAgreeAll,
    setAllAgreements,
  };
};
